import { writable } from "svelte/store";
import type { ViewerUiModel } from "./models.ts";

export const viewerModel = writable<ViewerUiModel | null>(null);
